module.exports = __webpack_public_path__ + "static/images/styles/images/icons/info.b65b33ab.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/info.png
// module id = 3641
// module chunks = 11